const AVAILABLE_CURRENCIES = {
  AMD: '֏',
  EUR: '€',
}

const CURRENCY = 'AMD'

const CURRENCY_SIGN = AVAILABLE_CURRENCIES[CURRENCY]

export { CURRENCY_SIGN }
